import { Component, Injector } from '@angular/core';
import { MetaGovernoService } from 'administrativo-lib';
import { BaseResourceListComponent, Coluna, Exercicio, ExercicioService, Filtro, FormatoExportacao, LoginContabil, MetaGoverno, Orgao, OrgaoService } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from "toastr";

@Component({
  selector: 'app-meta-governo-list',
  templateUrl: './meta-governo-list.component.html'
})
export class MetaGovernoListComponent extends BaseResourceListComponent<MetaGoverno, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public listaOrgaos: Orgao[] = [];
  public orgaoSelect: number = null;

  public exercicioAprovado: Exercicio;
  public desabilidarProgramacaoFinanceira: string = null;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private metaService: MetaGovernoService,
    protected exercicioService: ExercicioService,
    protected confirmationService: ConfirmationService,
    private orgaoService: OrgaoService) {
    super(metaService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected podeAlterar(_entidade: MetaGoverno): boolean {
    return this.login.sistema != 'controle-interno'
  }

  protected relations(): string {
    return 'programa,funcao,subfuncao,unidade,unidade.orgao';
  }

  protected condicoesGrid(): {} {
    return {
      ['ppa.id']: this.login.ppa.id, ['unidade.orgao.id']: this.orgaoSelect
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['programa.codigo$ASC', ''];
  }

  protected filtrosGrid(): Filtro {
    return {
      //number: ['programa.codigo', 'unidade.codigo', 'funcao.codigo'],
      text: ['programa.codigo', 'unidade.codigo', 'funcao.codigo', 'programa.nome', 'funcao.nome', 'unidade.nome'],
    };
  }

  public preencherGrid() {
    const parametros = this.obterParametros();

    parametros['relations'] = 'programa,funcao,subfuncao,unidade,unidade.orgao';
    if (parametros['programa.codigo$like']) {
      const codigo = parametros['programa.codigo$like'].replace('%', '');
      const codigoFormatado = codigo.padStart(4, '0');
      parametros['programa.codigo$like'] = `${codigoFormatado}%`;
    }
  
    if (parametros['programa.codigo$ge']) {
      const codigo = parametros['programa.codigo$ge'].toString().padStart(4, '0');
      parametros['programa.codigo$ge'] = codigo;
    }
  
    if (parametros['programa.codigo$le']) {
      const codigo = parametros['programa.codigo$le'].toString().padStart(4, '0');
      parametros['programa.codigo$le'] = codigo;
    }
    this.metaService
      .filtrar(
        this.paginaCorrente,
        this.limite,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          this.lista = lista.content;
          this.paginaTotal = lista.totalPages;
        },
        () => alert('erro ao retornar lista')
      );
  }
  

  public beforeInit(): void {
    this.usarFiltroPersonalizado = true;

    this.buscarOrgaos();
    this.orgaoSelect = this.login.orgao.id;
  }

  protected afterInit(): void {
    this.exercicioService
      .obterId(this.login.exercicio.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.exercicioAprovado = res;
        this.orcamentoAprovadoPermissao();
      });
  }

  public async orcamentoAprovadoPermissao() {
    if (this.exercicioAprovado?.orcamento_aprovado) {
      this.desabilidarProgramacaoFinanceira = "true";
    }
  }

  protected acaoRemover(model: MetaGoverno): Observable<MetaGoverno> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Código', coluna: 'programa.codigo' },
      { titulo: 'Descrição', coluna: 'programa.nome' },
      { titulo: 'Função', coluna: 'funcao.nome' },
      { titulo: 'Subfunção', coluna: 'subfuncao.nome' },
      { titulo: 'Unidade', coluna: 'unidade.nome' },
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    parametros['relations'] = 'programa,funcao,subfuncao,unidade';
    this.metaService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          if (formato === 'pdf') {
            this.imprimir(`LISTAGEM DE METAS DE GOVERNO:
          ${this.login.ppa.ppaperiodo.ano1} - ${this.login.ppa.ppaperiodo.ano4}`,
              this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao, 'landscape',
              'Listagem Metas de Governo', ['auto', 'auto', 'auto', 'auto', 'auto'], lista.content);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        () => alert('erro ao retornar lista')
      );
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public buscarOrgaos(): void {
    const parametros = {
      orderBy: 'codigo$ASC'
    };
    parametros['cidade.id'] = this.login.cidade.id;
    this.orgaoService
      .filtrar(
        1,
        -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        dados => {
          this.listaOrgaos = dados.content;
        },
        this.logErro
      );
  }

  public logErro(er: any): void {
    console.error(er);
    toastr.error(er.error.payload, 'Erro ao buscar orgão');
    throw er;
  }

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
      case 'controle-interno':
        this.router.navigate(['/planejamento']);
        break;
      default:
        this.sair();
        break;
    }
  }

  public obterColunasFiltroPersonalizado(): Coluna[] {
    const retorno: Coluna[] = [];

    retorno.push({ titulo: 'Programa', coluna: 'programa.nome', tipo: 'String', alignment: 'center', padrao: true, });
    retorno.push({ titulo: 'Código', coluna: 'programa.codigo', alignment: 'center', tipo: 'Number', padrao: true });
    retorno.push({ titulo: 'Descrição da função', coluna: 'funcao.nome', tipo: 'String', padrao: false, cols: 3 });
    retorno.push({ titulo: 'Código da Função', coluna: 'funcao.codigo', alignment: 'center', tipo: 'String', cols: 2, padrao: false });
    retorno.push({ titulo: 'Descrição unidade', coluna: 'unidade.nome', alignment: 'center', tipo: 'String', cols: 3, padrao: false });
    retorno.push({ titulo: 'Código Unidade', coluna: 'unidade.codigo', alignment: 'center', tipo: 'String', padrao: false, cols: 2 });

    return retorno;
  }

  public removerMeta(metaGov: MetaGoverno): void {
    this.confirmationService.confirm({
      message: `Gostaria de seguir com a exclusão da meta de governo ${metaGov?.programa.codigo}?`,
      header: "Exclusão de meta de governo",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      key: "meta_governo",
      accept: () => {
        this.metaService
          .remover(metaGov.id)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            () => {
              toastr.success("Registro removido com sucesso!");
              this.preencherGrid();
            },
            (err) => {
              toastr.error("Verifique se existe ação de governo vinculada a meta de governo.");
              console.error(err);
            }
          );
      },
    });
  }

  public podeAlterarMeta(): Boolean {
    return (
      !this.exercicioAprovado?.orcamento_aprovado
    );
  }

  public reordenarProgramas() {
    this.metaService.reordenarProgramas(this.orgaoSelect, this.login.ppa.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        toastr.success('Programas reordenadas com sucesso!');
        this.preencherGrid();
      }, (err) => {
        toastr.error('Falha ao reordenar os programas!');
        console.error(err);
      });
  }

}
